import React, { useState, useEffect, useRef } from "react";
import SequenceableControls from "./SequenceableControls";
import DrEditor from "./Editor";
import Spinner from "../../Spinner";
import SectionWithAdd from "./SectionWithAdd";

/**
 * <RichTextList syllabusId={} api={} type={} plType={} lookup_type_id={optional} editMode={} reqOptions={} focus={} focusKey={} lastUpdateType={} defaultText={} containerId={} canViewProgress={} canEditProgress={} progressA={} progAIndex={} toggleProgressA={} addItem={} />
 */
const StatefulRichTextSection = (props) => {
  try {
    const _isMounted = useRef(false);
    const {
      syllabusId,
      progAIndex,
      api,
      editMode,
      type,
      plType,
      reqOptions,
      lastUpdateType,
      updateTime,
      typeLookupId,
      sectionName,
    } = props;
    const url = `${api}${plType}`;
    const [items, setItems] = useState(props.items || []);
    const [maxSequence, setMaxSequence] = useState(items.length);
    const [dataReady, setDataReady] = useState(!!props.items);
    const [reload, setReload] = useState(!props.items);

    useEffect(function updateMounted() {
      _isMounted.current = true;
      return function cleanupMounted() {
        console.log("cleaup");
        _isMounted.current = false;
      };
    }, []);

    useEffect(
      function fetchItems() {
        if (reload) {
          apiCall(
            `${url}?${type}[syllabus_id]=${syllabusId}&${type}[type_lookup_id]=${typeLookupId}`,
            reqOptions("GET"),
            (res) => {
              res.json().then((data) => {
                if (_isMounted.current) {
                  setItems(data);
                  setMaxSequence(data.length);
                  setDataReady(true);
                  setReload(false);
                }
              });
            }
          );
        }
      },
      [reload]
    );

    useEffect(
      function reloadEffect() {
        if (
          (lastUpdateType === type ||
            lastUpdateType === `${type}-${typeLookupId}`) &&
          _isMounted
        ) {
          setReload(true);
        }
      },
      [updateTime]
    );

    const addItem = (opts, e) => {
      console.log("IS THE PROBLEM HERE?");
      const body = {};
      body[type] = {
        syllabus_id: syllabusId,
        sequence: opts["sequence"],
        type_lookup_id: typeLookupId,
      };
      apiCall(url, reqOptions("POST", body), (res) => setReload(true));
    };

    const removeItem = (opts, e) => {
      if (confirm("Are you sure you want to remove this item?")) {
        const { id } = opts;
        const body = {};
        body[type] = { syllabus_id: syllabusId, active: false };
        apiCall(`${url}/${id}`, reqOptions("PATCH", body), (res) =>
          setReload(true)
        );
      }
    };

    const updateItemSequence = (opts, e) => {
      const { id, index, value } = opts;
      const body = {};
      body[type] = { syllabus_id: syllabusId, sequence: value };
      apiCall(`${url}/${id}`, reqOptions("PATCH", body), (res) =>
        setReload(true)
      );
    };

    const display =
      items.length > 0 || editMode ? (
        <SectionWithAdd
          {...props}
          id={`${type}-section${typeLookupId}`}
          type={type}
          plType={plType}
          showProgress={props.canViewProgress}
          progIndex={progAIndex}
          addItem={addItem}
          sectionName={sectionName}
        >
          <table className="table table-bordered top-buffer sm-font">
            <tbody>
              {items.map((i, ix) => (
                <StatefulRichText
                  {...props}
                  key={`${type}-${i.id}`}
                  parentKey={`${type}-${i.id}`}
                  item={i}
                  description={i.description || ""}
                  ix={ix}
                  maxSequence={maxSequence}
                  handleChange={updateItemSequence}
                  removeItem={removeItem}
                  dataReady={dataReady}
                />
              ))}
            </tbody>
          </table>
        </SectionWithAdd>
      ) : (
        ""
      );

    return dataReady ? display : <Spinner />;
  } catch (e) {
    console.error(e);
  }
};

/**
 * <StatefulRichText {...props} item={} maxSequence={} ix={} />
 */
const StatefulRichText = (props) => {
  try {
    const {
      api,
      item,
      syllabusId,
      type,
      plType,
      reqOptions,
      maxSequence,
      ix,
      defaultText,
      focusKey,
      dataReady,
      parentKey,
      containerId,
      updateTime,
    } = props;
    const url = `${api}${plType}/${item.id}`;
    const [description, setDescription] = useState(props.description || "");
    const [timer, setTimer] = useState(null);
    const _isMounted = useRef(false);
    const _localUpdate = useRef(false);

    const updateDescription = (opts, e) => {
      if (description != e.target.value) {
        _localUpdate.current = true;
        setDescription(e.target.value);
      }
    };

    const debounce = (fn) => {
      if (timer) clearTimeout(timer);
      if (_isMounted.current) {
        setTimer(
          setTimeout(() => {
            fn();
          }, 300)
        );
      }
    };

    useEffect(() => {
      _isMounted.current = true;
      return () => {
        console.log("cleaup");
        _isMounted.current = false;
      };
    }, []);

    useEffect(() => {
      if (_localUpdate.current) {
        const body = { container_id: containerId };
        body[type] = { syllabus_id: syllabusId, description: description };
        debounce(() => {
          apiCall(url, reqOptions("PATCH", body));
        });
      }
    }, [description, props.description]);

    useEffect(() => {
      _localUpdate.current = false;
      setDescription(props.description);
    }, [props.description]);

    return (
      <tr id={parentKey} className={`test-${type}`}>
        <td className="d-flex justify-content-between align-items-top">
          <div
            className="d-flex justify-content-between w-75 align-items-top"
            onClick={(e) => props.focus(parentKey, e)}
          >
            <span className="xs-font">{item.sequence}.</span>
            <DrEditor
              updateType={type}
              defaultText={defaultText}
              text={description}
              parentKey={parentKey}
              handleChange={updateDescription}
              focusKey={focusKey}
              dataReady={dataReady}
            />
          </div>
          <SequenceableControls
            {...props}
            itemIndex={ix}
            parentKey={parentKey}
            maxSequence={maxSequence}
          />
        </td>
      </tr>
    );
  } catch (e) {
    console.error(e);
  }
};

const apiCall = (url, reqOptions, next) => {
  try {
    fetch(url, reqOptions).then((res) => {
      if (res.status === 401) {
        // alert('Unauthorized. Either your session has expired or you are not authorized to perform this action. Please try logging out and logging in again.')
        // if (confirm('Unauthorized. Either your session has expired or you are not authorized to perform this action. Redirect to login page? \n(Please note: if your session has expired, none of the changes you make to this syllabus will be saved until you log in again.)')) {
        //   sylContainer.props.history.push('/log_in');
        // }
        alert(
          "Not authorized to update the syllabus. Please reload the page and try again."
        );
      } else if (res.status >= 400) {
        alert(
          "There was an issue updating the syllabus. Please reload the page and try again."
        );
      } else if (next) {
        next(res);
      }
    });
  } catch (err) {
    //To Do: handle error
  }
};

export default StatefulRichTextSection;
